export const V1_HANDLE_SUCCESSFULLY_UPDATED_PASSENGERS =
  'V1_HANDLE_SUCCESSFULLY_UPDATED_PASSENGERS'

export default data => ({
  type: V1_HANDLE_SUCCESSFULLY_UPDATED_PASSENGERS,
  data,
})
